var $class="se2--wiztopic-press-release--accordion",$name="WiztopicPressRelease/accordion",$path="app/components/WiztopicPressRelease/partials/accordion/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';
import { css, keyNames } from 'configs';
import forEach from 'lodash/forEach';

const accordionItemTitleClassName = 'accordion-item-title';
const rotateClassName = 'rotate';

export default shell.registerPartial($this, ({ mount, addEventListener }) => {
  mount((element) => {
    const accordionItemTitleElements = element.querySelectorAll(`.${accordionItemTitleClassName}`);

    const toggleMenuItems = (toggler, item) => {
      const classAdded = item.classList.toggle(css.classNames.show);
      toggler.classList.toggle(rotateClassName);
      item.setAttribute('aria-expanded', classAdded.toString());
    };

    const onKeyDown = (e, item) => {
      const { code } = e;
      if (code === keyNames.tab) {
        item.classList.remove(rotateClassName);
        item.nextElementSibling.classList.remove(css.classNames.show);
        item.setAttribute('aria-expanded', 'false');
      } else if (code === keyNames.enter || code === keyNames.space) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggleMenuItems(item, item.nextElementSibling);
      }
    };

    forEach(
      accordionItemTitleElements,
      (itemTitle) => addEventListener(
        itemTitle,
        'click',
        () => {
          toggleMenuItems(itemTitle, itemTitle.nextElementSibling);
        },
      ),
    );

    forEach(
      accordionItemTitleElements,
      (itemTitle) => addEventListener(
        itemTitle.parentElement,
        'keydown',
        (e) => {
          onKeyDown(e, itemTitle);
        },
      ),
    );
  });
});
